import { AppInput } from './src/AppInput.js';

window.customElements.define('app-input', AppInput);
